<script setup>
import { Head, Link, useForm } from "@inertiajs/vue3";
import JetAuthenticationCard from "@/Components/Cards/AuthenticationCard.vue";
import AuthenticationCardLogo from "@/Components/AuthenticationCardLogo.vue";
import Checkbox from "@/Components/Checkbox.vue";
import InputError from "@/Components/InputError.vue";
import InputLabel from "@/Components/InputLabel.vue";
import PrimaryButton from "@/Components/PrimaryButton.vue";
import TextInput from "@/Components/TextInput.vue";
import ReCaptcha2 from "@/Components/Input/ReCaptcha2.vue";
import CountrySelectRegister from "@/Components/Input/CountrySelectRegister.vue";
import JetInputError from "@/Components/Input/InputError.vue";
import allCountries from "@/Composable/allCountries";


import { nextTick, onMounted, ref } from "vue";
const props = defineProps({
    fromDialog: {
        type: Boolean,
        default: false,
    },
});
const emit = defineEmits(['close']);

const closeDialog = () => {
    emit('close');
}

const form = useForm({
    lastName: "",
    name: "",
    email: "",
    phone: "",
    password: "",
    password_confirmation: "",
    terms: false,
    country_id: "",
    gender: "male",
    user_type: '',
    "g-recaptcha-response": "",
});
const phoneInput = ref(null);
onMounted(() => {
    nextTick(function () {
        phoneInput.value?.onInput();
    });
});
const verifyMethod = (response) => {
    form["g-recaptcha-response"] = response;
};
const submit = () => {
    form.post(route("register"), {
        onFinish: () => {
            form.reset("password", "password_confirmation", "g-recaptcha-response");
            // closeDialog();
        },
        onSuccess: () => {
            if (props.fromDialog) {
                closeDialog();
            }
            location.reload();
        },
    });
};
const visible = ref(false);
const confirmationVisible = ref(false);
</script>

<template>

    <Head title="Register" />

    <JetAuthenticationCard :fromDialog="fromDialog" class="overflow-y-scroll h-[95vh]">
        <!-- <template #logo>
      <AuthenticationCardLogo />
    </template> -->
        <div>
            <div class="flex" :class="fromDialog ? 'justify-between' : 'justify-center'">
                <h1 class="font-bold text-[22px] text-start h1">{{ __t("register") }}</h1>
                <v-btn @click="closeDialog" v-if="fromDialog" icon="mdi-close"
                    :class="fromDialog ? '' : 'hidden'"></v-btn>
            </div>
            <br />

            <hr>
            <br />


        </div>
        <form @submit.prevent="submit" class=" h-[90 vh]">
            <v-row>
                <v-col cols="12" md="6">
                    <v-text-field :label="__t('first_name')" hide-details ref="firstName" autofocus id="name"
                        v-model="form.name" type="text" class="block w-full mt-2 mb-4" required autocomplete="name">
                    </v-text-field>
                    <InputError class="mt-2" :message="form.errors.name" />
                </v-col>
                <v-col cols="12" md="6">
                    <v-text-field :label="__t('last_name')" hide-details id="lastName" v-model="form.lastName"
                        type="text" class="block w-full mt-2 mb-5" required autocomplete="lastName">
                    </v-text-field>
                    <InputError class="mt-2" :message="form.errors.lastName" />
                </v-col>
            </v-row>


            <div class="mt-0">
                <v-text-field :label="__t('email')" hide-details name="email" ref="email" id="email"
                    @focusout="validate" v-model="form.email" type="email" class="block w-full mt-2 mb-2" required>
                </v-text-field>
                <InputError class="mt-2" :message="form.errors.email" />
            </div>
            <div class="z-50 mt-0">

                <JetInputError class="mt-2" :message="form.errors.phone" />
            </div>
            <div class="mt-">
                <v-row>
                    <v-col cols="12" md="6" class="flex items-center mt-7 mt-md-0">
                        <!-- <JetLabel for="phone" :value="__t('phone')" class="mb-2 bblack-color-regester" /> -->
                        <div dir="ltr" class="z-50">
                            <!-- {{ countries }} -->
                            <v-no-ssr>
                                <vue-tel-input ref="phoneInput" v-model="form.phone" hide-details
                                    :allCountries="allCountries" mode="international" :inputOptions="{
                                        placeholder: __t('phone_number'),
                                        autocomplete: 'on',
                                        required: true,
                                    }" :dropdownOptions="{
                                        showDialCodeInList: true,
                                        showDialCodeInSelection: true,
                                        showFlags: true,

                                        showSearchBox: true,
                                    }" :preferredCountries="[
                    'QA',
                    'SY',
                    'TR',
                    'KW',
                    'IQ',
                    'SA',
                    'LY',
                    'AE',
                ]" class="z-50 rounded-lg max-h-12"></vue-tel-input>
                            </v-no-ssr>
                        </div>
                        <!-- <v-select v-model="form.gender" :label="__t('gender')" :items="[
              { title: __t('male'), value: 'male' },
              { title: __t('female'), value: 'female' },
            ]" hide-details>
            </v-select> -->
                    </v-col>
                    <v-col cols="12" md="6">
                        <div class="" v-if="is_enabled_module('country')">
                            <v-no-ssr>
                                <CountrySelectRegister :theme="light" col="12" class="my-6"
                                    v-model:country="form.country_id" :showInput="['country']" hide-details>
                                </CountrySelectRegister>
                            </v-no-ssr>
                            <InputError class="mt-2" :message="form.errors.country_id" />
                        </div>
                    </v-col>

                </v-row>

            </div>
            <v-row>
                <v-col cols="12" md="12">
                    <div class="mt-0">
                        <v-select :label="__t('user_type')" :items="['company', 'personal', 'freelancer', 'office']"
                            variant="outlined" required v-model="form.user_type"></v-select>
                            <InputError class="mt-2" :message="form.errors.user_type" />
                    </div>
                </v-col>
                <v-col cols="12" md="6">
                    <div class="mt-0">
                        <v-text-field :label="__t('password')" hide-details ref="firstPassword"
                            :append-inner-icon="visible ? 'mdi-eye-off' : 'mdi-eye'"
                            :type="visible ? 'text' : 'password'" dir="ltr" variant="outlined" required
                            autocomplete="new-password" v-model="form.password"
                            @click:append-inner="visible = !visible"></v-text-field>
                        <InputError class="mt-2" :message="form.errors.password" />
                    </div>
                </v-col>
                <v-col cols="12" md="6">

                    <div class="mt-0">
                        <v-text-field :label="__t('confirm_password')" hide-details id="password_confirmation" dir="ltr"
                            :append-inner-icon="confirmationVisible ? 'mdi-eye-off' : 'mdi-eye'"
                            :type="confirmationVisible ? 'text' : 'password'" variant="outlined" required
                            autocomplete="new-password" v-model="form.password_confirmation"
                            @click:append-inner="confirmationVisible = !confirmationVisible"></v-text-field>
                        <InputError class="mt-2" :message="form.errors.password_confirmation" />
                    </div>
                </v-col>
            </v-row>



            <div class="flex items-center justify-end mt-4">
                <InputError class="mt-2" :message="form.errors['g-recaptcha-response']" />
                <ReCaptcha2 @verified="verifyMethod" :reset="!!form.errors['g-recaptcha-response']">
                </ReCaptcha2>
            </div>

            <div v-if="$page.props.jetstream.hasTermsAndPrivacyPolicyFeature" class="mt-4">
                <InputLabel for="terms">
                    <div class="flex items-center">
                        <Checkbox id="terms" v-model:checked="form.terms" name="terms" required />

                        <div class="ms-2">
                            {{ __t('i_agree_with') }}
                            <a target="_blank" v-if="$page.props.setting.privacyPolicy"
                                :href="route('page.one', $page.props.setting.privacyPolicy)"
                                class="text-sm text-gray-600 underline rounded-md dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 ">{{
                                    __t('policy') }}</a>

                            <!-- {{$page.props.setting.privacyPolicy}} -->

                        </div>
                    </div>
                    <InputError class="mt-2" :message="form.errors.terms" />
                </InputLabel>
            </div>
            <div class="flex flex-col-reverse items-center justify-end mt-4 md:flex-row">
                <Link :href="route('login')"
                    class="text-sm text-gray-600 underline rounded-md dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 dark:focus:ring-offset-gray-800">
                {{ __t('already_registered') }}
                </Link>

                <v-btn class="mt-3 mb-3 ms-4" @click="submit" :class="{ 'opacity-25': form.processing }"
                    :disabled="form.processing">
                    {{ __t("register") }}
                </v-btn>
            </div>
        </form>
    </JetAuthenticationCard>
</template>
